import { render, staticRenderFns } from "./gcsg.vue?vue&type=template&id=ce22ad54&scoped=true&"
import script from "./gcsg.vue?vue&type=script&lang=js&"
export * from "./gcsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce22ad54",
  null
  
)

export default component.exports